/**
 * Merk-labels — leesbare naam per merk, zoals een medewerker het aan de
 * telefoon zou noemen. Eén bron van waarheid zodat de softphone overal
 * hetzelfde toont (rinkelen én tijdens het gesprek).
 */

import type { Brand } from './types';

const BRAND_LABELS: Record<Brand, string> = {
  CINCO: 'Cinco Cleaning',
  KLEDA: 'Kleda',
  SOFASAVER: 'SofaSaver',
  SCHOONHUISSHOP: 'Schoonhuisshop',
  VLOERKLEEDREINIGEN: 'Vloerkleedreinigen',
  BANKREINIGEN: 'Bankreinigen',
};

/** Leesbare merknaam; valt terug op de rauwe sleutel bij een onbekend merk. */
export function brandLabel(brand: Brand | string): string {
  return BRAND_LABELS[brand as Brand] ?? String(brand);
}
